const toOneOf = (items = []) =>
  (Array.isArray(items) ? items : [])
    .filter((item) => item && Object.prototype.hasOwnProperty.call(item, 'const'))
    .map((item) => ({ const: item.const, title: item.title }));

const schema = (siteTypes, siteStatuses) => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'title',
    },
    type_ids: {
      type: 'string',
      title: 'site_type',
      default: undefined,
      oneOf: toOneOf(siteTypes),
    },
    status: {
      type: 'string',
      title: 'site_status',
      default: undefined,
      oneOf: toOneOf(siteStatuses),
    },
    is_active: {
      type: 'number',
      title: 'activity',
      oneOf: [
        { const: 1, title: 'active' },
        { const: 0, title: 'inactive' },
      ],
    },
  },
});

export default schema;
